<!--suppress HtmlUnknownAttribute -->
<script lang="ts">
    import {Level, Noun, type Word} from '$lib/classes/data/word';

    export let art: Word['art']
    export let frequency: Word['base']['frequency']
    export let level: Word['base']['level']
    export let phonetic: Word['base']['phonetic']
    export let plural: Noun['plural'] | null
</script>

<div id="facts-art">{art === 'Num' ? 'Number' : art}</div>
<div>Frequency <span class="emphasize">{frequency}</span></div>
<div>Level <span class="emphasize">{level === Level.NoLevel ? '-' : level}</span></div>
<div>{phonetic}</div>
<div id="facts-plural"
     style:visibility={plural ? 'visible' : 'hidden'}>
    <div>plural</div>
    <div>{plural}</div>
</div>

<style>
    div {
        display: flex;
        align-items: center;
        min-height: 1.8rem;
        white-space: pre-wrap;
        /*border: 1px solid teal;*/
    }

    #facts-art {
        color: var(--color-accent);
        font-weight: var(--font-bold);
        font-size: 1.15rem;
        margin-bottom: 1rem;
    }

    #facts-plural {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    #facts-plural div:last-child {
        transform: translateY(-.5rem);
        font-weight: var(--font-emph);
        /*border: 1px solid purple;*/
    }

    @media (max-width: 1000px) {
        div {
            font-size: .9rem;
            min-height: 1.5rem;
        }
    }

</style>